<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:NyukyoNum
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/06 | 富士通株式会社         | 新規作成
// 01.01.00 | 2024/03/29 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div :class="[classDiv != '' ? classDiv : '']">
		<input
			type="button"
			class="contents__btn--plusminus"
			value="－"
			:tabindex="-1"
			@click="clickMinus()"
		>
		<list-box
			ref="ninzuNum"
			class="contents__input--select width-auto margin__right-5 margin__left-5"
			:modelValue="modelValue"
			:name="name"
			:list-items="disp.ninzuItems"
			:blank-flg="false"
			:require-flg="requireFlg"
			:tabindex="Number(tabindex) <= 0 ? tabindex:String(Number(tabindex) + 1)"
			@update:modelValue="changeNum"
		/>
		<input
			type="button"
			class="contents__btn--plusminus"
			value="＋"
			:tabindex="-1"
			@click="clickPlus()"
		>
		人&nbsp;
	</div>
</template>

<script>
import ListBox from '@/components/ListBox.vue';
import { co_isEmpty } from '@/common/checkUtility.js';

export default {
	components: {
		'list-box': ListBox,
	},
	props: {
		modelValue: {type: String, default: ''},				// 入力値
		name: {type: String, default: ''},						// 項目名
		requireFlg: {type: Boolean, default: false},			// true : 必須
		startNum: {type: String, default: '0'},					// 選択範囲（開始）
		endNum: {type: String, default: '0'},					// 選択範囲（終了）
		tabindex: {type: String, default: '0'},					// タブインデックス
		changenuNyukyo: {type: Function, default: function() {
				return null
			}
		},														// 並び替えイベント
		classDiv: {type: String, default: ''},					// コントロールエリアのスタイル
	},
	emits: ['update:modelValue'],
	data: function () {
		return {
			disp: {
				ninzuItems: [], 
			},
		}
	},
	computed: {

	},
	watch: {
		startNum: function () {
			this.createNinzuList();
		},
		endNum: function () {
			this.createNinzuList();
		},
		modelValue: async function() {
			// 入居人数変更を通知
			this.changenuNyukyo(this.modelValue);
		},
	},
	created: async function() {
		// 人数リスト作成
		this.createNinzuList();
	},
	methods: {
		// 人数リスト作成
		createNinzuList: function () {

			// 人数リスト設定
			let ninzuItemList = [];
			for (let i = Number(this.startNum)-1; i < Number(this.endNum); i++) {
					ninzuItemList.push({
										idCd : String(Number(i + 1)), nmCd : String(Number(i + 1))
										});
			}
			this.disp.ninzuItems = ninzuItemList;

			if (co_isEmpty(this.modelValue)) {
				// 選択値未設定の場合は開始値を設定
				this.$emit( 'update:modelValue', this.startNum );
			}
		},
		// ＋ボタン押下
		clickPlus: function () {
			this.$emit( 'update:modelValue', Number(this.modelValue) < Number(this.endNum) ? String(Number(this.modelValue) + 1) : this.modelValue );
		},
		// －ボタン押下
		clickMinus: function () {
			this.$emit( 'update:modelValue', Number(this.modelValue) > Number(this.startNum) ? String(Number(this.modelValue) - 1) : this.modelValue );
		},
		// 人数リスト変更
		changeNum: function (val) {
			this.$emit( 'update:modelValue', val );
		},
		// 選択値取得
		getValue: function() {
			return this.modelValue;
		},
		//エラー表示設定
		setError: function() {
			this.$refs.ninzuNum.setError();
		},
		//エラー表示消去
		clearError: function() {
			this.$refs.ninzuNum.clearError();
		},
		// 妥当性チェック
		validate: function () {

			return this.$refs.ninzuNum.validate();
		},
		// フォーカス設定
		focus: function() {
			this.$refs.ninzuNum.focus();
		}
	},
}
</script>

<style scope>
</style>